import * as React from 'react';
import { SVGProps } from 'react';

const IconBoldSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.504 5.85C9.168 5.367 9.6 4.65 9.6 3.917 9.6 2.308 8.344 1 6.8 1H2v10h5.4C8.832 11 10 9.783 10 8.292A2.71 2.71 0 0 0 8.504 5.85ZM4 2.667h2.396c.664 0 1.2.558 1.2 1.25 0 .691-.536 1.25-1.2 1.25H4v-2.5Zm2.6 6.666H4v-2.5h2.6c.664 0 1.2.559 1.2 1.25 0 .692-.536 1.25-1.2 1.25Z" />
  </svg>
);
export default IconBoldSizeXs;
